<template>
  <div class="index">
    <div>
      <div ref="sidebar" class="sidebar">
        <div class="sidebar-content" :class="[density]">
          <div class="menu icon-button" title="Close menu" @click="closeSidebar">
            <i class="material-icons gray">menu</i>
          </div>
          <authentication-bar @closeSidebar="closeSidebar"></authentication-bar>
          <lists v-if="loggedIn"
                 :updater="updater"
                 :currentListId="currentListId"
                 @update:currentList="updateCurrentList"
                 @closeSidebar="closeSidebar"
                 :density="density"></lists>
        </div>
      </div>
      <div ref="overlay" class="overlay" @click="closeSidebar">
        <div ref="overlayopacity" class="overlay-opacity"></div>
      </div>

      <div ref="headerbar" class="header-bar" :class="[density]">
        <div class="menu icon-button" title="Open menu" @click="openSidebar">
          <i class="material-icons gray">menu</i>
        </div>
        <div ref="actionbuttons" class="action-buttons">
          <div class="refresh icon-button" title="Refresh data" @click="updateTasks">
            <i class="material-icons gray">refresh</i>
          </div>
          <div class="add-task icon-button" title="Add a task" @click="addTask">
            <i class="material-icons gray">add</i>
          </div>
          <div class="unindent icon-button" title="Unindent task" @click="unindentSelectedTask" @mousedown.prevent>
            <i class="material-icons gray">format_indent_decrease</i>
          </div>
          <div class="indent icon-button" title="Indent task" @click="indentSelectedTask" @mousedown.prevent>
            <i class="material-icons gray">format_indent_increase</i>
          </div>
          <div class="move-up icon-button" title="Move task up" @click="moveUpSelectedTask" @mousedown.prevent>
            <i class="material-icons gray">arrow_upward</i>
          </div>
          <div class="move-down icon-button" title="Move task down" @click="moveDownSelectedTask" @mousedown.prevent>
            <i class="material-icons gray">arrow_downward</i>
          </div>
          <div class="more icon-button" v-if="density === 'mobile'" title="More actions" @click="showMoreActions" @mousedown.prevent>
            <i class="material-icons gray">more_vert</i>
          </div>
          <div class="clear icon-button" title="Clear completed tasks" @click="clearCompletedTasks" @mousedown.prevent>
            <i class="material-icons gray">clear_all</i>
          </div>
          <div v-if="$refs.tasklist != null && !$refs.tasklist.showHidden">
            <div class="show-hidden icon-button" title="Show hidden tasks" @click="showHiddenTasks" @mousedown.prevent>
              <i class="material-icons gray">unfold_more</i>
            </div>
          </div>
          <div v-else>
            <div class="show-hidden icon-button" title="Hide hidden tasks" @click="hideHiddenTasks" @mousedown.prevent>
              <i class="material-icons gray">unfold_less</i>
            </div>
          </div>
          <div class="settings icon-button" title="Settings" @click="showSettings = true" @mousedown.prevent>
            <i class="material-icons gray">settings</i>
          </div>
        </div>
      </div>

      <settings v-if="showSettings"
                @close="showSettings = false; updateLocalSettings()"
                @saveTasks="saveTasks"></settings>
      <div class="in-progress-bar" :class="{ saving: !saved, loading: loading }"></div>
      <div v-if="aSaveFailed" class="save-failed">
        API call failed, state may be inconsistent. Please refresh.
      </div>
      <task-list ref="tasklist"
                 class="task-list"
                 v-if="loggedIn"
                 :updater="updater"
                 :currentListId="currentListId"
                 :loading.sync="loading"
                 :density="density"></task-list>

    </div>
  </div>
</template>

<script>
import AuthenticationBar from '../components/AuthenticationBar.vue'
import Lists from '../components/Lists.vue'
import Settings from '../components/Settings.vue'
import TaskList from '../components/TaskList.vue'

export default {
  name: 'index',
  components: {
    AuthenticationBar,
    Lists,
    TaskList,
    Settings
  },

  data () {
    return {
      // Bool indicating if the user is logged in.
      loggedIn: false,

      // The current list to show.
      currentListId: '',

      updater: new this.$Updater(this.$gapi, (s) => { this.saved = s }, () => { this.aSaveFailed = true }),

      // True if the set of tasks is being loaded from the server.
      loading: false,

      // True if all the modifications have been saved on the server.
      saved: true,

      // True if any save failed on the server.
      aSaveFailed: false,

      showSettings: false,

      density: 'desktop'
    }
  },

  methods: {
    updateState: async function () {
      this.loggedIn = this.$gapi.isLoggedIn()
      this.currentListId = this.getCurrentListIdFromLocalStorage()
      this.updater.newSetAccessToken(this.$gapi.getAccessTokenFromLocalStorage())
    },

    updateCurrentList: async function (listId) {
      localStorage.setItem('settings.currentListId', listId)
      this.currentListId = listId
    },

    getCurrentListIdFromLocalStorage: function () {
      let value = localStorage.getItem('settings.currentListId')
      if (value != null) {
        return value
      }
      return ''
    },

    updateLocalSettings: function () {
      if (localStorage.getItem('settings.density') !== null) {
        this.density = localStorage.getItem('settings.density')
      }
    },

    openSidebar: function () {
      this.$refs.sidebar.style.left = '0'
      this.$refs.overlay.style.width = '100%'
      this.$refs.overlayopacity.style.opacity = '0.6'
    },

    closeSidebar: function () {
      this.$refs.sidebar.style.left = '-20em'
      this.$refs.overlay.style.width = '0'
      this.$refs.overlayopacity.style.opacity = '0'
    },

    showMoreActions: function () {
      if (this.$refs.headerbar.style.height === '' || this.$refs.headerbar.style.height === '2.5em') {
        this.$refs.headerbar.style.height = '6em'
        this.$refs.actionbuttons.style.height = '6em'
      } else {
        this.$refs.headerbar.style.height = '2.5em'
        this.$refs.actionbuttons.style.height = '2.5em'
      }
    },

    updateTasks: function () {
      this.$refs.tasklist.updateTasks()
    },

    unindentSelectedTask: function () {
      this.$refs.tasklist.unindentSelectedTask()
    },

    indentSelectedTask: function () {
      this.$refs.tasklist.indentSelectedTask()
    },

    moveUpSelectedTask: function () {
      this.$refs.tasklist.moveUpSelectedTask()
    },

    moveDownSelectedTask: function () {
      this.$refs.tasklist.moveDownSelectedTask()
    },

    saveTasks: function () {
      this.$refs.tasklist.saveTasks()
    },

    addTask: function () {
      this.$refs.tasklist.addTaskAtTop()
    },

    clearCompletedTasks: function () {
      this.$refs.tasklist.clearCompletedTasks()
    },

    showHiddenTasks: function () {
      this.$refs.tasklist.showHidden = true
    },

    hideHiddenTasks: function () {
      this.$refs.tasklist.showHidden = false
    }
  },

  async mounted () {
    this.$gapi.addAuthStateChangeCallback(this.updateState.bind(this))
    await this.$gapi.client()
    await this.$gapi.refreshAccount()
    this.updateLocalSettings()
    this.updateState()

    // Every 30 minutes, refresh the access tokens so that we never lose them.
    setInterval(async () => {
      console.log('refreshing')
      await this.$gapi.refreshAccount()
      this.updater.newSetAccessToken(this.$gapi.getAccessTokenFromLocalStorage())
    }, 1800000)
  }
}
</script>

<style scoped>
div.sidebar {
  height: 100%;
  width: 20em;
  position: fixed;
  z-index: 4;
  top: 0;
  left: -20em;
  background-color: #ddd;
  overflow-x: hidden;
  transition: 0.5s;
}

div.sidebar-content {
  width: 20em;
  display: block;
}

div.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

div.overlay-opacity {
  background-color: rgba(0, 0, 0, 0.9);
  height: 100%;
  width: 100%;
  transition: 0.5s;
  opacity: 0;
}

div.header-bar {
  top: 0em;
  width: 100%;
  background-color: #ddd;
}

div.header-bar.desktop, div.action-buttons {
  height: 1.8em;
  line-height: 1.5em;
}

div.header-bar.mobile, div.action-buttons {
  height: 2.5em;
  line-height: 2.5em;
}

div.action-buttons {
  overflow: hidden;
}

.material-icons.gray {
  color: rgba(0, 0, 0, 0.54);
}

div.icon-button {
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

div.header-bar div.icon-button {
  float: left;
}

div.header-bar.desktop div.icon-button {
  margin-right: 0.75em;
}

div.header-bar.mobile div.icon-button {
  margin-right: 0.9em;
}

div.desktop .icon-button {
  width: 24px;
}

div.mobile .icon-button {
  width: 36px;
}

div.mobile .material-icons {
  font-size: 36px;
}

div.in-progress-bar {
  height: 2px;
  width: 100%;
}

div.in-progress-bar.loading {
  background-color: blue;
  position: relative;
  left: -200px;
  width: 100%;
  content: "";
  animation: loading 2s linear infinite;
}

div.in-progress-bar.saving {
  background-color: red;
  position: relative;
  left: -200px;
  width: 100%;
  content: "";
  animation: loading 2s linear infinite;
}

div.save-failed {
  background-color: burlywood;
  color: black;
}

@keyframes loading {
    from {right: 0; width: 30%;}
    to {left: 100%; width: 30%;}
}

.task-list {
  position: absolute;
  width: 100%;
  height: calc(100% - 8px);
  overflow: hidden;
}

</style>
